import Image from 'next/image'

/** Откуда взяты оценка и отзыв: сама Евирма, Яндекс Карты или 2ГИС — со значком, его узнают быстрее подписи. */
export type ReviewSourceCode = 'evirma' | 'yandex' | 'two_gis'

const sources: Record<ReviewSourceCode, { src: string; label: string }> = {
  evirma: { src: '/front/images/logo/evirma-logo-sign.svg', label: 'Евирма' },
  yandex: { src: '/front/images/map-logo/yandex-maps-logo.svg', label: 'Яндекс Карты' },
  two_gis: { src: '/front/images/map-logo/two-gis-logo.svg', label: '2ГИС' },
}

export const ReviewSource = ({ source, className = '' }: { source: ReviewSourceCode; className?: string }) => {
  const { src, label } = sources[source]

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <Image src={src} alt="" width={16} height={16} className="size-4 rounded-[3px]" unoptimized />
      {label}
    </span>
  )
}
